import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { FormInput, FormInputMultiline } from 'elements/Inputs/FormInput/';
import { FormDropdown } from 'elements/Inputs/FormInput/Dropdown/Dropdown';
import { StyledLabel } from 'elements/Label/Label';
import { selectInspectionChecklistData } from './InspectionChecklist.data';
import { StyleDropdown } from '../AsFoundTestTableSection/AsFoundTestSection.styled';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const InspectionChecklistSection = (props) => {
    const { selectedTag, formData, changeHandler, formName, isFormReadOnly, userRole } = props;
    const classes = useStyles();
    const formDropdownInput = (field) => field.isDropdown ? (
        <StyleDropdown
            formName={formName}
        >
            <FormDropdown
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                placeholder={field.placeholder}
                handleChange={changeHandler}
                options={field.options}
                isRequired={field.isRequired}
                width={field.width}
                inputTextAlign={field.inputTextAlign}
                labelWidth={field.labelWidth}
                readOnly={field.readOnly || isFormReadOnly}
                marginBottom={field.marginBottom}
                borderBottom={field.borderBottom}
                height={field.height}
                paddingPlaceholder={field.paddingPlaceholder}
                arrowMarginTop={field.arrowMarginTop}
                inputMarginRight={field.inputMarginRight}
                userRole={userRole}
                noDefaultOption={field.noDefaultOption}
            />
        </StyleDropdown>
    )
        : (
            <FormInput
                id={field.key}
                name={field.key}
                label={field.label}
                value={field.value}
                isRequired={field.isRequired}
                readOnly={field.readOnly || isFormReadOnly}
                handleChange={changeHandler}
                direction={field.direction}
                textAlign={field.textAlign}
                type={field.type}
                padding={field.padding}
                width={field.width}
                labelWidth={field.labelWidth}
                marginLeft={field.marginLeft}
                maxLength={field.maxLength}
                marginRight={field.marginRight}
                fontSize={field.fontSize}
                marginBottom={field.marginBottom}
                marginTop={field.marginTop}
                borderRight={field.borderRight}
                height={field.height}
                borderBottom={field.borderBottom}
                borderTop={field.borderTop}
                borderLeft={field.borderLeft}
                isLabelNew={field.isLabelNew}
                inputMarginRight={field.inputMarginRight}
                isLabelBold={field.isLabelBold}
                userRole={userRole}
                fontWeight={field.fontWeight}
            />
        );
    const formMultilineInput = (field) => field.isMultiLine
        ? (
            <FormInputMultiline
                rows={2}
                id={field.key}
                name={field.key}
                value={field.value}
                maxLength={field.maxLength}
                handleChange={changeHandler}
                inputWidth={field.inputWidth}
                userRole={userRole}
                width={field.labelWidth}
                marginRight={field.marginRight}
                borderBottom={field.borderBottom}
                borderTop={field.borderTop}
                borderLeft={field.borderLeft}
                borderRight={field.borderRight}
                inputMarginRight={field.inputMarginRight}
                readOnly={field.readOnly || isFormReadOnly}
                marginBottom={field.marginBottom}
            />
        )
        : formDropdownInput(field);

    return (
        <Grid container spacing={1} className={classes.root}>
            {
                selectInspectionChecklistData(selectedTag, formName, formData).rows.map(row => (
                    <Grid item container xs={12} key={row.key} style={{ padding: '0' }}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {field.isLabel
                                    ? (
                                        <StyledLabel
                                            id={field.key}
                                            label={field.label}
                                            fontWeight={field.fontWeight}
                                            textAlign={field.textAlign}
                                            labelWidth={field.labelWidth}
                                            padding={field.padding}
                                            marginLeft={field.marginLeft}
                                            fontSize={field.fontSize}
                                        >
                                            {field.label}
                                        </StyledLabel>
                                    )
                                    : formMultilineInput(field)}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    userRole: Home.userRole
});
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InspectionChecklistSection);

InspectionChecklistSection.propTypes = {
    changeHandler: PropTypes.func,
    formData: PropTypes.object,
    formName: PropTypes.string,
    isFormReadOnly: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
